<style lang="scss" scoped>

    .myAmpleon .main .container {
        width: auto;
    }

    .myAmpleon .content {
        // There is some margin-top added elsewhere for the content class on this breakpoint
        // We don't need it on this page
        @media screen and (max-width: 767px) {
            margin-top: 0;
        }
    }

    .sidebar, .banner {
        display: none;
    }

    .content {
        left: 0;
        width: 100% !important;
    }

    h3.page-title {
        color: #000 !important;
        font-size: 24px;
        line-height: 29px;
    }

    .row__registration-successful {
        min-height: 100vh;

        @media (max-width: 991px) {
            flex-direction: column-reverse;
            min-height: auto;
        }

        .parametric-intro {
            margin: 0;
        }

        .page-title {

            @media (max-width: 767px) {
                padding: 15px 0 !important;
            }
        }

        .image-section {

            @media (max-width: 991px) {
                height: 270px;
            }

            @media (max-width: 767px) {
                height: 402px;
            }
        }
    }

    .top-bar {
        background-color: #003b71;
        height: 60px;
        width: 100%;
        top: 50px;
        left: 0;
        z-index: 2;
        overflow: hidden;
    }

    .row--flex {
        display: flex;
        flex-wrap: wrap;
        margin: 0;
    }

    .image-section {
        display: flex;
        flex-direction: column;
        font-family: "Open Sans", sans-serif;
        position: relative;
        height: auto;
        background-image: url("../assets/images/register-img.jpg");
        background-position: center;
        -webkit-background-size: cover;
        background-size: cover;
        background-repeat: no-repeat;
    }

    .overlay {
        opacity: 0.8;
        color: #fff;
        background: #003B71;
        width: 100%;
        height: 100%;
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
    }

    .svg-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 300px;
        height: 170px;

        path {
            fill: #ffffff;
        }
    }

    .col-spacing-75 {
        padding: 0 75px;

        @media (max-width: 991px) {
            padding: 0 25px;
        }

        @media (max-width: 767px) {
            padding: 0 15px;
        }
    }

    .form-check-label {
        margin: 0 0 0 20px;
        font-size: 12px;
        font-weight: 300;
        line-height: 13px;
        transform: translateY(-2px);
    }

    .form-textarea {
        width: 100%;
    }

    .invalid-feedback {
        color: red;
        margin-left: 12px;
        margin-bottom: 0;
    }

    .parametric-intro {
        margin: 0;
        padding-top: 43px !important;
    }

    .form-control {
        padding: 5px 18px;
        border-color: #ddd;
        box-shadow: none;
        font-size: 14px;
        line-height: 20px;

        &::-webkit-input-placeholder { /* Edge */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &:-ms-input-placeholder { /* Internet Explorer 10-11 */
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }

        &::placeholder {
            color: #000;
            font-size: 14px;
            font-weight: lighter;
        }
    }

    .form-group {
        margin-bottom: 22px;
    }
</style>

<template>
    <div class="registration-wrapper">
        <div class="top-bar"></div>
        <div class="row row--flex row__registration-successful">
            <div class="col-md-6 col-spacing-75">
                <div class="parametric-intro">
                    <h3 class="page-title">Registration and Login Support</h3>
                </div>

                <form @submit.prevent="handleSubmit">
                    <div class="row form-row">
                        <div class="form-group col-md-12">
                            <input type="text" v-model="user.firstName" class="form-control" id="firstName"
                                   placeholder="First Name *"
                                   :class="{ 'is-invalid': formErrors && $v.user.firstName.$error }">
                            <p v-if="formErrors && !$v.user.firstName.required" class="invalid-feedback">First name is
                                required.</p>
                        </div>
                        <div class="form-group col-md-12">
                            <input type="text" v-model="user.lastName" class="form-control" id="lastName"
                                   placeholder="Last Name *"
                                   :class="{ 'is-invalid': formErrors && $v.user.lastName.$error }">
                            <p v-if="formErrors && !$v.user.lastName.required" class="invalid-feedback">Last name is
                                required.</p>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="form-group col-md-12">
                            <input type="text" v-model="user.email" class="form-control" id="inputEmail"
                                   placeholder="Email *" :class="{ 'is-invalid': formErrors && $v.user.email.$error }">
                            <div v-if="formErrors && $v.user.email" class="invalid-feedback">
                                <p v-if="formErrors && !$v.user.email.required">E-mail address is required.</p>
                                <p v-else-if="!$v.user.email.email">Please enter a valid e-mail address.</p>
                            </div>
                        </div>

                        <div class="form-group col-md-12">
                            <input type="text" v-model="user.confirmEmail" class="form-control" id="confirmEmail"
                                   placeholder="Confirm E-mail *"
                                   :class="{ 'is-invalid': formErrors && $v.user.confirmEmail.$error }">
                            <div v-if="formErrors && $v.user.confirmEmail.$error" class="invalid-feedback">
                                <p v-if="formErrors && !$v.user.confirmEmail.sameAsEmail">E-mail addresses don't match.
                                    Please try again.</p>
                                <p v-else-if="!$v.user.confirmEmail.email">Please re-type your e-mail address.</p>
                            </div>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="form-group col-md-12">
                            <textarea class="form-control form-textarea" id="description" v-model="user.textArea"
                                      placeholder="Briefly describe your registration or login problem*"
                                      :class="{ 'is-invalid': formErrors && $v.user.confirmEmail.$error }"></textarea>
                            <div v-if="formErrors && $v.user.textArea.$error" class="invalid-feedback">
                                <p>Please describe your problem.</p>
                            </div>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="form-group form-group-check-second col-md-12">
                            <div class="form-check">
                                <span class="custom-checkbox custom-checkbox-wrapper">
                                    <input class="custom-checkbox__input" v-model="user.terms" type="checkbox"
                                           id="checkboxTerms"
                                           :class="{ 'is-invalid': formErrors && $v.user.terms.$error }"/>
                                    <span class="custom-checkbox__checkmark">
                                    </span>
                                </span>
                                <label class="form-check-label custom-control-label" for="checkboxTerms">I have read and
                                    accept the <a href="https://www.ampleon.com/about/terms-of-use.html">Terms of
                                        Use</a> and <a href="https://www.ampleon.com/about/privacy.html">Privacy
                                        Policy</a> *</label>
                            </div>
                            <div v-if="formErrors && $v.user.terms.$error" class="invalid-feedback">
                                <p>Please acknowledge that you have read and understand our Terms of Use and Privacy
                                    Policy.</p>
                            </div>
                        </div>
                    </div>

                    <div class="row form-row">
                        <div class="form-group col-md-12">
                            <FileUpload maxAttachmentCount="5" v-on:change="getFiles"/>
                        </div>
                    </div>
                    <RecapchaTerms></RecapchaTerms>
                    <div class="row form-row">
                        <div class="form-group col-md-12">
                            <button type="submit" :disabled="isPending" class="btn btn-primary register-button">Submit
                            </button>
                        </div>
                    </div>
                </form>
            </div>

            <div class="col-md-6 image-section">
                <div class="overlay">
                    <div class="svg-wrapper">
                        <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                             viewBox="0 0 302 172" style="enable-background:new 0 0 302 172;" xml:space="preserve">
                            <path fill="#ffffff" class="st0" d="M151,0.9c21.6,0,31.3,11,34.8,38.1L198,139.2c1,8.1,1.9,9.3,5.8,9.3c3.3,0,4.4-1.2,5.4-9.3l12.2-100.1
                                c3.3-27.2,13.7-38.1,34.8-38.1c23,0,33.4,11,35.4,38.1l9.1,120c0.8,9.5-1.7,12-11.2,12h-3.9c-9.5,0-12-2.3-12.6-12l-8.3-119.8
                                c-0.8-11.2-3.1-14.1-9.1-14.1c-5.2,0-7.9,2.9-9.1,14.1l-14.1,104.3c-2.9,20.5-9.1,27.6-28.8,27.6c-17.4,0-25.9-6.8-28.8-27.6
                                L160.5,39.3c-1.2-11.2-3.9-14.1-9.3-14.1h-0.4c-5.4,0-8.1,2.9-9.3,14.1l-14.3,104.3c-2.9,20.7-11.4,27.6-28.8,27.6
                                c-19.7,0-25.9-7-28.8-27.6L55.5,39.3c-1.2-11.2-3.9-14.1-9.1-14.1c-6,0-8.3,2.9-9.1,14.1l-8.3,119.8c-0.8,9.5-3.1,12-12.6,12h-3.9
                                c-9.5,0-12-2.3-11.2-12l9.1-120C12.3,11.9,22.7,0.9,45.7,0.9c20.9,0,31.3,11,34.8,38.1l12.2,100.1c1,8.1,2.1,9.3,5.4,9.3
                                c3.9,0,4.8-1.2,5.8-9.3l12.2-100.1C119.7,11.7,129.4,0.9,151,0.9z"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {required, email, sameAs} from "vuelidate/lib/validators";
    import {UserService} from "../common/api.service";
    import {SEND_SUPPORT_TICKET, FINALIZE_ACTION} from "../store/actions.type";
    import {STATUS, mapAsyncGetters} from "../store/utils/async";
    import FileUpload from "../components/FileUpload";
    import RecapchaTerms from "./ReCaptchaTerms";

    export default {
        name: "RegistrationAndLoginSupport",
        components: {
            RecapchaTerms,
            FileUpload
        },
        data() {
            return {
                user: {
                    firstName: "",
                    lastName: "",
                    email: "",
                    confirmEmail: "",
                    textArea: "",
                    terms: "",
                    files: [],
                    token: ""
                },
                formErrors: false
            };
        },
        validations: {
            user: {
                firstName: {required},
                lastName: {required},
                email: {required, email},
                confirmEmail: {required, sameAsEmail: sameAs('email')},
                textArea: {required},
                terms: {
                    checked(value) {
                        return value
                    }
                }
            }
        },
        computed: {
            ...mapAsyncGetters(SEND_SUPPORT_TICKET)

        },
        watch: {
            status: function (newValue) {
                if (this.isFinished) {
                    if (newValue === STATUS.SUCCESS) {
                        this.$router.push("registration-and-login-support-success");
                    } else if (newValue === STATUS.FAILURE) {
                        this.$router.push("registration-and-login-support-error");
                    }
                }
            }
        },
        methods: {
            async handleSubmit(e) {
                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.formErrors = true;
                } else {
                    this.user.token = await this.$recaptcha('registrationAndLoginSupport');
                    await this.$store.dispatch(SEND_SUPPORT_TICKET, this.user)
                        .then(() => this.$store.dispatch(FINALIZE_ACTION, SEND_SUPPORT_TICKET));
                }
            },
            getFiles(files) {
                if (files) {
                    this.user.files = files;
                }
            },
        }
    };
</script>


